import { CopyOutlined, DownOutlined, EditOutlined, FilterOutlined } from '@ant-design/icons'
import {
  Dropdown,
  Popover,
  Select,
  Space,
  Switch,
  Empty,
  Input,
  Pagination,
  Spin,
  Tabs,
  Tree,
  Table,
  Button,
  Tooltip,
  Image,
  message,
} from 'antd'
import { useEffect, useMemo, useRef, useState } from 'react'
import { SAside, SDrawerOrModal, SGeneralForms, SMessage } from 'shj-components'
import SpaceImg from '@/assets/space.png'
import styles from './index.module.less'
import GeneralList from '../GeneralList'
import ProductList from '../ProductList'
import { RightConfigArea } from '../RightConfigArea'
import {
  additionSearchForSpecialAdd,
  additionSearchPage,
  generalSearchPage,
  getSelectGeneralTerm,
  getTradeEnums,
  listBrand,
  listProductCategory,
  projectSearchPage,
  queryActivity,
  queryActivityProduct,
  saveBudgetDtl,
  subtractSearch,
  updateBudgetField,
  upDownSearchPage,
} from '@/services/order'
import { useUpdateEffect } from 'ahooks'
import { isArray, isBoolean, uniqueId } from 'lodash-es'
import { getUser, treeToOneArr } from '@/common/utils'
import TagCheckBox from '@/components/TagCheckBox'
import SubComfirmModal from '../SubConfirmModal'
import tagsMap from '../../utils'
import { getProductEnums } from '@/services/product'
import { render } from 'react-dom'
const { Search } = Input
import dayjs from 'dayjs'

// 配置不通选材类型下的搜索条件显示
const typeSearchFlag = {
  ACTIVITY: {
    activity: true,
  },
  ADD: {
    productCategory: true,
    brand: true,
    addType: true,
    prodType: true,
    mainMaterial: true,
  },
  SUB: {
    subType: true,
    brand: true,
  },
  GENERAL: {
    general: true,
    brand: true,
    mainMaterial: true,
  },
  PROJECT: {
    productCategory: true,
    brand: true,
    mainMaterial: true,
  },
  UP_DOWN: {
    general: true,
    brand: true,
    mainMaterial: true,
  },
}
interface PropType {
  open: boolean
  onClose: (a, b) => void
  chooseTypeList: any // 选材类型列表
  selectType: any // 选材类型 判断进入当前抽屉的选材类型
  setSelectType: (e) => void
  spaceId: any // 空间id
  budgetId: any // 预算id
  spaceOneArray: any // 空间树转数组
  btnInfo: any
  chooseGeneralId: any // 通项id
}
export default function SelectDrawer(props: PropType) {
  const {
    open,
    onClose,
    chooseTypeList,
    selectType,
    budgetId,
    spaceId,
    spaceOneArray,
    setSelectType,
    btnInfo,
    chooseGeneralId,
  } = props
  const [typeName, setTypeName] = useState<string>('')
  const [multipleOpen, setMultipleOpen] = useState<boolean>(false) // 批量设置空间
  const [selectMaterialObj, setSelectMaterialObj] = useState<any>({}) // 左侧选择的数据
  const [currentSearchParams, setCurrentSearchParams] = useState<any>({}) //设置当前参数
  const [typeList, setTypeList] = useState<any>([])
  const [generalList, setGeneralList] = useState<any>([])
  const [generalId, setGeneralId] = useState<any>(undefined) // 通项ID
  const [searchKeyWord, setSearchKeyWord] = useState<string>('')
  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [addType, setAddType] = useState<string>('PRODUCT') // 增项-来源类型
  const [categoryList, setCategoryList] = useState<any>([]) // 产品分类列表数据
  const [productCategoryIds, setProductCategoryIds] = useState<any>(['ALL']) // 分类
  const [chooseTableColumn, setChooseTableColumn] = useState<any>(undefined) // 表格
  const [brandList, setBrandList] = useState<any>([]) // 品牌列表
  const [brandId, setBrandId] = useState<any>('all') // 品牌id
  const [record, setRecord] = useState<any>(undefined) // 增项 通项添加选材数据
  const [openComfirmModal, setOpenComfirmModal] = useState<boolean>(false) // 弹窗确认选材
  const [budgetQtyFormularOpen, setBudgetQtyFormularOpen] = useState(false) // 预算量计算式弹窗
  const [recordItem, setRecordItem] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [recordInfo, setRecordInfo] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [qtyFormularLoading, setQtyFormularLoading] = useState(false) // 预算量计算式loading
  const [productTypeList, setProductTypeList] = useState<any>([]) // 产品类型列表
  const [productSourceTypeBus, setProductSourceTypeBus] = useState<any>('all') // 主材施工类型
  const [productSourceTypeBusList, setProductSourceTypeBusList] = useState<any>([]) // 主材施工类型
  const [activityList, setActivityList] = useState<any[]>([]) // 活动列表
  const [activityId, setActivityId] = useState<any>(undefined) // 活动ID
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [prodType, setProdType] = useState<any>('all') // 产品类型
  const [carData, setCarData] = useState<any[]>([]) // 选材车所有数据
  const user = getUser()
  // const cacheStr = chooseSelectMode //缓存key
  const budgetQtyFormularRef = useRef<any>(null)
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])
  const [searchValue, setSearchValue] = useState('')
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const [qtyFormularReadOnly, setQtyFormularReadOnly] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 30,
    total: 0,
  })
  const categoryListRef = useRef<any>(null)

  useEffect(() => {
    gio?.('setUserId', user?.workNumber)
    gio?.('people.set', {
      tenantId: user?.tenantId, //租户ID,
      ucenterUserName: user?.name, // 平台用户名称
      ucenterUserId: user?.id, //平台用户ID
      loginWorkNumber: user?.workNumber, //登录工号
      phone: user?.phone, //手机号
    })
  }, [])
  const [depsLoading, setDepsLoading] = useState(true)
  const items = [
    {
      key: 'PRODUCT',
      label: '商品',
    },
    {
      key: 'GENERAL',
      label: '已减通项',
    },
    {
      key: 'REDUCED_STANDARD',
      label: '已减标配',
    },
  ]
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const showNationalTagRender = (item: any, type?) => {
    if (type === 'list') {
      if (item?.showTags && isArray(item?.showTags)) {
        return item?.showTags?.map((tag: any) => {
          return (
            <span
              className={'normal_tag_style'}
              style={{
                color: tagsMap.NATIONAL_UPPLEMENT?.color,
                backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                marginRight: '8px',
              }}
            >
              {tag?.tagName}
            </span>
          )
        })
      } else {
        return <></>
      }
    } else {
      // 显示国补
      if (item.packDtlList?.length > 0) {
        // 造数据
        item?.product?.combinationInfo.forEach((el: any) => {
          item?.packDtlList.forEach((pack: any) => {
            if (pack?.prdId === el?.id) {
              el.selectSkuId = pack?.sourceItemSnapshot?.productSku?.id
            }
          })
        })

        // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
        let proList = item?.product?.combinationInfo
          ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
          ?.filter(item => item.required || (!item.required && item.checked))
        let allNational = false
        if (proList?.length) {
          allNational = proList?.every((el: any) => {
            if (el.selectSkuId) {
              return el?.skuList?.find((sku: any) => sku.id === el.selectSkuId)?.showTags
            }
            return false
          })
          if (allNational) {
            return (
              <span
                className={'normal_tag_style'}
                style={{
                  color: tagsMap.NATIONAL_UPPLEMENT?.color,
                  backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap.NATIONAL_UPPLEMENT.name}
              </span>
            )
          }
        }
      } else {
        let showTags = item?.product?.skuList?.find(
          (sku: any) => sku.id === item.prdSkuId
        )?.showTags
        if (showTags && isArray(showTags)) {
          return showTags?.map((tag: any) => {
            return (
              <span
                className={'normal_tag_style'}
                style={{
                  color: tagsMap.NATIONAL_UPPLEMENT?.color,
                  backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tag?.tagName}
              </span>
            )
          })
        } else {
          return <></>
        }
      }
    }
  }
  const SkuRender = item => {
    if (!item) {
      return
    }
    // 判断是否有 多规格 组合 报价属性

    let modifyText
    if (
      (item?.dynaOptions && Object.keys(item?.dynaOptions).length) ||
      item?.materialDynaOptions?.length
    ) {
      const strings: string[] = []
      if (item?.materialDynaOptions?.length) {
        item?.materialDynaOptions?.forEach((el: any) => {
          strings.push(`${el.name}：${el.optionName}`)
        })
      }
      for (let key in item?.dynaOptions) {
        strings.push(`${item?.dynaOptions[key].argName}：${item?.dynaOptions[key].valueName}`)
      }
      modifyText = strings.map((str: string) => <div key={str}>{str}</div>)
    } else {
      modifyText = <span></span>
    }

    return (
      <div className={styles.skuCard}>
        <div className={styles.skuCard_baseInfo}>
          <div className={styles.baseInfo_imgBox}>
            <Image.PreviewGroup items={item?.imageUrls}>
              <Image src={item?.mainPic} />
            </Image.PreviewGroup>
          </div>
          <div>
            {showNationalTagRender(item)}
            <span className={styles.name_box}>{item.name}</span>
            <p className={styles.spuBox}>
              <span>SKU：</span>
              {item?.prdSkuId}
              <CopyOutlined
                style={{ marginLeft: '8px' }}
                className="copyIcon"
                onClick={() => {
                  clickToCopy(item?.prdSkuId)
                }}
              />
            </p>
          </div>
        </div>
        <div className={styles.midify_box}>
          {modifyText && <div className={styles.dynation_box}>{modifyText}</div>}
          {item?.packDtlList && item?.packDtlList.length && (
            <div className={styles.group_box}>
              <div className={styles.group_box_title}>产品包明细</div>
              <div className={styles.item_list}>
                {item?.packDtlList?.map(el => {
                  return (
                    <div key={el.id}>
                      <div className={styles.skuCard_baseInfo}>
                        <div className={styles.baseInfo_imgBox}>
                          <Image.PreviewGroup items={el?.sourceItemSnapshot?.productSku?.imageUrls}>
                            <Image src={el?.sourceItemSnapshot?.productSku?.mainPicUrl} />
                          </Image.PreviewGroup>
                        </div>
                        <div>
                          {showChildNationalTag(
                            item?.product?.combinationInfo?.find(kit => kit?.id === el?.prdId)
                          )}
                          <p className={styles.item_title}>
                            {el?.sourceItemSnapshot?.productSku?.spuName}
                          </p>
                          <p className={styles.spuBox}>
                            <span>SPU：</span>
                            {el?.prdId}
                            <CopyOutlined
                              style={{ marginLeft: '8px' }}
                              className="copyIcon"
                              onClick={() => {
                                clickToCopy(el?.prdId)
                              }}
                            />
                          </p>
                          <div className={styles.modifyText_list}>{modifyTextRender(el)}</div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
  const showChildNationalTag = (kit: any) => {
    // // 当确定skuid后 显示国补
    let showTags = kit?.skuList?.find((sku: any) => sku.id === kit?.selectSkuId)?.showTags
    if (showTags && isArray(showTags)) {
      return showTags?.map((tag: any) => {
        return (
          // <div className={tagsMap[tag.tagCode]} style={{ width: 'fit-content', maxWidth: '75px' }}>
          //   <Tooltip placement="topLeft" title={tag.tagName}>
          //     {tag.tagName}
          //   </Tooltip>
          // </div>
          <span
            className={'normal_tag_style'}
            style={{
              color: tagsMap.NATIONAL_UPPLEMENT?.color,
              backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
              marginRight: '8px',
            }}
          >
            {tag.tagName}
          </span>
        )
      })
    } else {
      return <></>
    }
  }
  const modifyTextRender = item => {
    let modifyText
    if (
      (item?.dynaOptions && Object.keys(item?.dynaOptions).length) ||
      item?.materialDynaOptions?.length
    ) {
      const strings: string[] = []
      if (item?.materialDynaOptions?.length) {
        item?.materialDynaOptions?.forEach((el: any) => {
          strings.push(`${el.name}：${el.optionName}`)
        })
      }
      for (let key in item?.dynaOptions) {
        strings.push(`${item?.dynaOptions[key].argName}：${item?.dynaOptions[key].valueName}`)
      }
      modifyText = strings.map((str: string) => <div key={str}>{str}</div>)
    } else {
      modifyText = <span></span>
    }
    return modifyText
  }
  const clickToDetail = record => {
    window.open(`/order/materialSelectionLibrary/materialDetail/${record?.prdId}`, '_blank')
  }
  useEffect(() => {
    const typeList = [...chooseTypeList]
    console.log(selectType)
    console.log(chooseGeneralId)
    // 添加通项或者项目选材
    if (open) {
      switch (selectType) {
        case 'PROJECT':
          fetchProductSourceTypeBusList()
          fetchCategoryList()
          setTypeName('项目')
          fetchBrandList()

          break
        case 'GENERAL':
          fetchProductSourceTypeBusList()
          setTypeName('通项')
          fetchBrandList()

          break
        case 'ADD':
          // 增项
          setTypeName('增项')
          fetchCategoryList()
          fetchProductSourceTypeBusList()
          fetchProductTypeList()
          fetchBrandList()
          break
        case 'UP_DOWN':
          setTypeName('升降级')
          fetchProductSourceTypeBusList()
          fetchBrandList()
          // 升降级
          break
        case 'SUB': {
          setTypeName('减项')
          const newColumns = [
            {
              title: '序号',
              width: 60,
              dataIndex: 'order',
              render: (text, record, index) => index + 1,
            },
            {
              title: '项目类型',
              width: 110,
              dataIndex: 'typeNameList',
              render: (text, record) => {
                if (text && isArray(text)) {
                  return (
                    text &&
                    text?.map((str: string) => (
                      <div
                        key={str}
                        className={'normal_tag_style'}
                        style={{
                          color: tagsMap[str]?.color,
                          backgroundColor: tagsMap[str]?.bgColor,
                          marginRight: '8px',
                        }}
                      >
                        {tagsMap[str]?.name}
                      </div>
                    ))
                  )
                }
              },
              filters: [
                { text: '通项', value: 'GENERAL' },
                { text: '标配', value: 'STANDARD' },
                { text: '非标配', value: 'NOTSTANDARD' },
                { text: '增项', value: 'ADD' },
                { text: '减项', value: 'SUB' },
                { text: '升降级', value: 'UP_DOWN' },
                { text: '活动', value: 'ACTIVITY' },
                { text: '项目', value: 'PROJECT' },
              ],
              filterSearch: true,
              onFilter: (value, record) => {
                return record.typeNameList?.includes(value)
              },
            },
            {
              title: '商品类型',
              width: 150,
              dataIndex: ['productSku', 'prodCateName'],
              render: (text, record) => {
                return (
                  <div>
                    {record?.typeNameList?.includes('GENERAL')
                      ? record?.goodsTypeName
                      : text
                        ? text.split('/')?.[text.split('/')?.length - 1]
                        : ''}
                  </div>
                )
              },
            },
            {
              title: '商品',
              dataIndex: 'referenceName',
              ellipsis: true,
              render: (text, record) => {
                return (
                  <div>
                    {record?.typeNameList?.length === 1 &&
                    record?.typeNameList?.[0] === 'GENERAL' ? (
                      <span></span>
                    ) : (
                      <div className={styles.productItemBox}>
                        <Popover
                          overlayClassName={styles.Sku_popover}
                          className="skuName_box"
                          content={() => SkuRender(record?.budgetDtl)}
                          arrow={false}
                          placement="bottomLeft"
                        >
                          <span onClick={() => clickToDetail(record?.budgetDtl)}>
                            {showNationalTagRender(record, 'list')}

                            {text}
                          </span>
                        </Popover>
                      </div>
                    )}
                  </div>
                )
              },
            },
            {
              title: '单位',
              width: 60,
              dataIndex: 'unitName',
            },
            {
              title: '单价',
              width: 90,
              align: 'right',
              dataIndex: 'saleCustPrice',
            },
            {
              title: '可减量',
              width: 80,
              dataIndex: 'availableQuantity',
              align: 'right',
            },
            {
              title: '所在位置',
              width: 180,
              dataIndex: 'spacePathNames',
              render: (text, record) => {
                if (record.budgetItemList?.length > 0) {
                  return <span>{record.budgetItemList[0].showName}</span>
                }
              },
            },
            {
              title: '操作',
              width: 90,
              dataIndex: 'order',
              render: (text, record) => {
                return (
                  <Button type="link" style={{ paddingLeft: 0 }} onClick={() => clickToSub(record)}>
                    减项
                  </Button>
                )
              },
            },
          ]
          setChooseTableColumn([...newColumns])
          // 减项
          break
        }
        case 'ACTIVITY':
          setTypeName('活动')
          fetchActivityList()
          // 活动
          break
        default:
          break
      }
      setTypeList(typeList)
      getGeneralList()
      let cacheMode: any = localStorage.getItem('chooseSelectMode')
      cacheMode = cacheMode ? cacheMode : 'false'
      cacheMode = JSON.parse(cacheMode || '')
      setMultipleOpen(cacheMode)
    }
  }, [open, selectType])

  // 获取分类下拉数据
  const fetchCategoryList = async () => {
    setDepsLoading(true)
    try {
      const res = await listProductCategory({
        data: {
          quoteBudgetId: budgetId,
          queryDefaultCategory: true,
        },
      })
      const data = handleTreeData(res)
      categoryListRef.current = [{ label: '全部', id: 'ALL' }, ...data]
      setCategoryList([{ label: '全部', id: 'ALL' }, ...data])
      setProductCategoryIds(['ALL'])
      setDepsLoading(false)
    } catch (error) {
      setDepsLoading(false)
    }
  }
  // 获取品牌数据
  const fetchBrandList = async () => {
    listBrand({
      data: {
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      let array = Array.isArray(res) ? res : []
      array = array.map(item => {
        return {
          label: item.sourceName,
          value: item.sourceId,
        }
      })
      setBrandList([...array])
      // setBrandId('不限')
    })
  }
  const fetchProductSourceTypeBusList = async () => {
    const list = await getTradeEnums(
      'com.shj.saas.plus.trade.domain.quote.enums.ProductSourceTypeBusEnum'
    )
    setProductSourceTypeBusList(
      list?.map(item => {
        return {
          label: item.description,
          value: item.key,
        }
      })
    )
  }
  //  树结构数据处理
  const handleTreeData = data => {
    if (Array.isArray(data)) {
      data.map(item => {
        item.title = item.label
        item.value = item.id
        if (item.children && item.children.length) {
          handleTreeData(item.children)
        }
      })
    }
    return data
  }
  // 获取活动数据
  const fetchActivityList = async () => {
    let activityList: any = await queryActivity({
      params: {
        budgetId: budgetId,
      },
    })

    setActivityId('all')
    setActivityList(activityList)
  }
  const getGeneralList = async () => {
    let res: any = await getSelectGeneralTerm({
      data: {
        quoteBudgetId: budgetId,
        spaceId: spaceId,
        isUpDown: selectType === 'UP_DOWN',
      },
    })
    setGeneralId(chooseGeneralId || generalId || res[0]?.id)
    setGeneralList(res)
  }
  const fetchProductTypeList = async () => {
    const productTypeList = await getProductEnums('com.shj.saas.plus.product.enums.ProductTypeEnum')
    setProductTypeList(
      productTypeList?.map(item => {
        return {
          label: item.description,
          value: item.key,
        }
      })
    )
  }
  const onClick = ({ key }) => {
    if (selectType !== 'SUB' && multipleOpen && carData?.length) {
      SMessage.confirm({
        title: `切换选材`,
        content: '确认切换选材吗？切换后批量空间设置将被清空',
        okText: '继续',
        onOk: () => {
          const showName = typeList?.find((item: any) => item?.code === key)?.showName
          setTypeName(showName)
          setSelectType(key)
          setSelectMaterialObj({})
        },
      })
      return
    }
    let showName = typeList?.find((item: any) => item?.code === key)?.showName
    setTypeName(showName)
    setSelectType(key)
    // 清空数据
    setSelectMaterialObj({})
  }
  const onChangeSwitch = (open: boolean) => {
    setMultipleOpen(open)
    localStorage.setItem('chooseSelectMode', open ? 'true' : 'false')
    if (open) {
      gio?.('track', 'chooseMultipleOpen', {
        user_id: user?.workerNumber,
        event_time: new Date().getTime(),
        state: open ? '开启' : '关闭',
      })
    } else {
      gio?.('track', 'chooseMultipleClose', {
        user_id: user?.workerNumber,
        event_time: new Date().getTime(),
        state: open ? '开启' : '关闭',
      })
    }
  }
  const titleRender = () => {
    return (
      <div className={styles.titleBox}>
        <div className={styles.titleBox_left}>
          <Dropdown
            menu={{
              items: typeList?.map((item: any) => {
                return {
                  key: item?.code,
                  label:
                    item.type === 'PROJECT' || item.type === 'GENERAL'
                      ? item.showName + '选材'
                      : '新增' + item.showName,
                }
              }),
              onClick,
              selectable: true,
              selectedKeys: [selectType],
            }}
          >
            <Space style={{ cursor: 'pointer' }}>
              {selectType === 'PROJECT' || selectType === 'GENERAL'
                ? typeName + '选材'
                : '新增' + typeName}
              <DownOutlined />
            </Space>
          </Dropdown>
          <img src={SpaceImg} alt="" />
          <div className={styles.titleBox_space}>
            {spaceOneArray?.find(item => item?.id === spaceId)?.title}
          </div>
        </div>
        {addType === 'GENERAL' || addType === 'REDUCED_STANDARD' || selectType === 'SUB' ? null : (
          <div className={styles.titleBox_right}>
            <Switch checked={multipleOpen} onChange={onChangeSwitch} size={'small'} />
            <p>批量设置空间</p>
          </div>
        )}
      </div>
    )
  }
  // 分页
  const onChangePage = (page, pageSize) => {
    let pageInfo = { ...pagination }
    pageInfo.current = page
    pageInfo.pageSize = pageSize
    // setTableLoading(true)
    clickToSearch(pageInfo)
    setPagination({
      ...pagination,
      ...pageInfo,
    })
  }

  const onSearch = (keyWord: any) => {
    setSearchKeyWord(keyWord)
  }
  // 监听参数变化
  useEffect(() => {
    open && clickToSearch()
  }, [
    open,
    brandId,
    productCategoryIds,
    generalId,
    searchKeyWord,
    activityId,
    addType,
    selectType,
    prodType,
    productSourceTypeBus,
  ])
  const onBrandChange = e => {
    setBrandId(e)
  }
  const onProductTypeChange = e => {
    setProdType(e)
  }

  const clickToSearch = async (pageInfo?: any, keyWords?: any) => {
    console.log(depsLoading, 'depsLoading111111111')

    // 当有其他依赖还没加载完时 退出请求
    if (depsLoading && !categoryListRef.current && selectType === 'ADD') {
      return
    }
    let api // 根据选材类型获取不同的接口
    let query: any = {
      quoteBudgetId: budgetId,
      type: selectType,
      searchKeyWord: searchKeyWord,
      brandId: brandId && brandId !== 'all' ? brandId : null,
    }
    query.current = pageInfo ? pageInfo?.current : 1
    query.pageSize = pageInfo ? pageInfo?.pageSize : 30
    setLoading(true)
    console.log(productCategoryIds, 'productCategoryIds')
    console.log(categoryListRef.current, 'categoryList')
    let newList = treeToOneArr(categoryListRef.current)
    try {
      // 分类查询请求
      switch (selectType) {
        case 'GENERAL':
          delete query.addType
          query.searchSkusPrice = true // 查询价格区间
          query.generalId = generalId
          query.productSourceTypeBus =
            productSourceTypeBus && productSourceTypeBus !== 'all' ? productSourceTypeBus : null
          if (!query.generalId) {
            setLoading(false)
            setData([])
            return
          }
          api = generalSearchPage
          break
        case 'PROJECT':
          delete query.addType
          query.searchSkusPrice = true // 查询价格区间
          query.generalId = ''
          query.quoteBudgetItemId = spaceId
          query.productCategoryIds = productCategoryIds?.includes('ALL')
            ? newList?.map(item => item?.id).filter(item => item !== 'ALL')
            : productCategoryIds?.filter(item => item !== 'ALL')
          query.productSourceTypeBus =
            productSourceTypeBus && productSourceTypeBus !== 'all' ? productSourceTypeBus : null
          api = projectSearchPage
          break
        case 'ADD':
          query.generalId = ''
          query.addType = addType //初次请求默认为产品
          query.spaceId = spaceId
          query.productCategoryIds = productCategoryIds?.includes('ALL')
            ? newList?.map(item => item?.id).filter(item => item !== 'ALL')
            : productCategoryIds?.filter(item => item !== 'ALL')
          query.prodType = prodType && prodType !== 'all' ? prodType : null
          query.productSourceTypeBus =
            productSourceTypeBus && productSourceTypeBus !== 'all' ? productSourceTypeBus : null
          if (query.addType === 'PRODUCT') {
            query.searchSkusPrice = true // 查询价格区间
            api = additionSearchPage
          } else if (query.addType === 'GENERAL') {
            api = additionSearchForSpecialAdd
          } else {
            api = additionSearchForSpecialAdd
          }
          break

        case 'UP_DOWN':
          if (!generalId) {
            setLoading(false)
            setData([])
            return
          }
          query.productSourceTypeBus =
            productSourceTypeBus && productSourceTypeBus !== 'all' ? productSourceTypeBus : null
          query.generalId = generalId
          delete query.addType
          api = upDownSearchPage
          break
        case 'ACTIVITY':
          delete query.addType
          query.activityId = activityId && activityId !== 'all' ? activityId : null
          api = queryActivityProduct

          break
        case 'SUB':
          delete query.addType
          query.quoteBudgetItemId = spaceId
          query.prodType = null
          api = subtractSearch

          break
        default:
          break
      }
      // 处理查询参数
      // query.prodType = type === 'ADD' ? query.prodType : null
      // setQueryParams({ ...query })
      let res = await api({ data: { ...query } })
      console.log(res, 'res')

      if (
        query.type === 'SUB' ||
        query.type === 'ACTIVITY' ||
        (query.type === 'ADD' && query.addType !== 'PRODUCT')
      ) {
        setData([...res])
      } else {
        res.list = res?.list.map(item => {
          return {
            ...item,
            key: uniqueId(),
          }
        })
        setData([...res?.list])
        setPagination({
          pageSize: Number(res?.pageSize || 30),
          current: Number(res?.currentPageId || 1),
          total: res?.count,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      // setTableLoading(false)
    }
  }
  const onAddTypeChange = key => {
    let newColumns: any = []
    if (key === 'GENERAL') {
      newColumns = [
        {
          title: '序号',
          dataIndex: 'order',
          width: 60,
          render: (text, record, index) => index + 1,
        },
        {
          title: '项目类型',
          width: 100,
          dataIndex: 'typeName',
          render: (text: any, record: any) => (
            <div
              key={'GENERAL'}
              className={'normal_tag_style'}
              style={{
                color: tagsMap['GENERAL']?.color,
                backgroundColor: tagsMap['GENERAL']?.bgColor,
                marginRight: '8px',
              }}
            >
              {tagsMap['GENERAL']?.name}
            </div>
          ),
        },
        {
          title: '通项名称',
          dataIndex: 'referenceName',
        },
        {
          title: '单位',
          dataIndex: 'order',
        },
        {
          title: '单价',
          dataIndex: 'saleCustPrice',
        },
        {
          title: '已减量',
          dataIndex: 'reducedSize',
          render: (text, record) => {
            return text && text * -1
          },
        },
        {
          title: '所在位置',
          dataIndex: 'spacePathNames',
          render: (text, record) => {
            if (text && isArray(text)) {
              return text.join('-')
            }
            return text
          },
        },
        {
          title: '操作',
          dataIndex: 'handle',
          render: (text, record) => {
            return (
              <Button type="link" onClick={() => clickToAdd(null, record)}>
                添加
              </Button>
            )
          },
        },
      ]
    } else if (key === 'REDUCED_STANDARD') {
      newColumns = [
        {
          title: '序号',
          dataIndex: 'order',
          width: 60,
          render: (text, record, index) => index + 1,
        },
        {
          title: '项目类型',
          width: 100,
          dataIndex: 'typeName',
          render: (text: any, record: any) => (
            <div
              key={'STANDARD'}
              className={'normal_tag_style'}
              style={{
                color: tagsMap['STANDARD']?.color,
                backgroundColor: tagsMap['STANDARD']?.bgColor,
                marginRight: '8px',
              }}
            >
              {tagsMap['STANDARD']?.name}
            </div>
          ),
        },
        {
          width: 100,
          title: '商品类型',
          dataIndex: ['productSku', 'prodCateName'],
          render: text => <div>{text ? text.split('/')?.[text.split('/')?.length - 1] : ''}</div>,
        },
        {
          title: '商品',
          width: 190,
          dataIndex: 'referenceName',
          ellipsis: true,
          render: (text, record) => {
            return (
              <div className={styles.productItemBox}>
                <Popover
                  overlayClassName={styles.Sku_popover}
                  className="skuName_box"
                  content={() => SkuRender(record?.budgetDtl)}
                  arrow={false}
                  placement="bottomLeft"
                >
                  <span onClick={() => clickToDetail(record?.budgetDtl)}>{text}</span>
                </Popover>
              </div>
            )
          },
        },
        {
          title: '单位',
          width: 75,
          dataIndex: 'unitName',
        },
        {
          width: 75,
          title: '单价',
          dataIndex: 'saleCustPrice',
        },
        {
          width: 75,
          title: '已减量',
          dataIndex: 'reducedSize',
          render: (text, record) => {
            return text && text * -1
          },
        },
        {
          title: '所在位置',
          width: 200,
          dataIndex: 'spacePathNames',
          render: (text, record) => {
            if (text && isArray(text)) {
              return text.join('-')
            }
            return text
          },
        },
        {
          title: '操作',
          width: 75,
          dataIndex: 'handle',
          render: (text, record) => {
            return (
              <Button type="link" onClick={() => clickToAdd(null, record)}>
                添加
              </Button>
            )
          },
        },
      ]
    }
    setChooseTableColumn([...newColumns])

    setAddType(key)
  }
  const onSelect = keys => {
    console.log(keys, '44444444')
    let ids: any = []
    if (keys && keys[0]) {
      if (keys[0] === 'ALL') {
        setProductCategoryIds(['ALL'])
        return
      }
      let newList = treeToOneArr(categoryList)
      let infoObj: any = newList.find(item => item.id === keys[0])
      findAllId(infoObj, ids)
      setProductCategoryIds(ids)
    }
  }
  const findAllId = (obj: any, ids) => {
    ids.push(obj.id)
    if (obj.children && obj.children.length > 0) {
      obj.children.forEach(item => {
        findAllId(item, ids)
      })
    }
  }
  useEffect(() => {
    console.log('selectMaterialObj', selectMaterialObj)
  }, [selectMaterialObj])
  const onBudgetQtyFormularRef = () => {
    const { onFormRef } = budgetQtyFormularRef.current || {}
    return onFormRef?.()
  }
  const clickToAdd = (record, item?: any) => {
    console.log(record, item)
    setRecordItem(item)
    setBudgetQtyFormularOpen(true)
    onBudgetQtyFormularRef().setFieldsValue({
      remark: item.remark,
      budgetQtyFormular: item.standardFlag ? item.auditStandardQtyFormular : item.budgetQtyFormular,
    })
  }
  const clickToSub = record => {
    record.checked = true // 选到右侧默认勾选
    record.spaceChecked = [] // 造数据 空间应用
    // record.generalId = type === 'ADD' || type === 'PROJECT' ? '' : generalId
    record.calculate = ''
    // 区分通项和产品
    record.onlyShowTitle = record.referenceType === 'GENERAL'

    // record.addType = queryRef.current.addType
    setRecord(record)
    // 如果套件明细数据，过滤调不显示的数据
    if (record.productSpu?.combinationInfo?.length > 1) {
      record.productSpu.combinationInfo = record.productSpu?.combinationInfo.filter(
        item => item.allowView
      )
      // 打开弹窗
      setConfirmOpen(true)
      return
    }
    // 如果有规格可以选择 提前选择
    // if (record.productSpu?.skuSize > 1) {
    //   setConfirmOpen(true)
    // } else {
    setConfirmOpen(true)
    // }
  }

  const onBudgetQtyFormularSubmit = async () => {
    console.log(onBudgetQtyFormularRef().getFieldsValue(), recordItem)
    setQtyFormularLoading(true)
    saveBudgetDtl({
      data: postData({ ...recordItem }),
    })
      .then(async () => {
        setBudgetQtyFormularOpen(false)
        const query: any = {
          quoteBudgetId: budgetId,
          type: selectType,
          brandId: brandId && brandId !== 'all' ? brandId : null,
          searchKeyWord,
        }
        let newList = treeToOneArr(categoryList)
        query.generalId = ''
        query.addType = addType //初次请求默认为产品
        query.spaceId = spaceId
        // query.productCategoryIds = productCategoryIds?.filter(item => item !== 'ALL')
        query.productCategoryIds = productCategoryIds?.includes('ALL')
          ? newList?.map(item => item?.id).filter(item => item !== 'ALL')
          : productCategoryIds?.filter(item => item !== 'ALL')
        query.prodType = prodType && prodType !== 'all' ? prodType : null
        query.productSourceTypeBus =
          productSourceTypeBus && productSourceTypeBus !== 'all' ? productSourceTypeBus : null
        const res: any = (await additionSearchForSpecialAdd({ data: { ...query } })) || []
        setData([...res])
      })
      .finally(() => {
        setQtyFormularLoading(false)
      })
  }
  const postData = item => {
    item.quoteBudgetId = budgetId
    item.type = selectType // 为通项传值
    item.spaceChecked = item?.budgetItemList?.length ? [item?.budgetItemList[0]?.id] : []
    // 空间明细字段处理
    if (item.spaceChecked && item.spaceChecked.length) {
      const array: any = []
      array.push({
        itemId: item?.budgetItemList[0]?.id, // 空间标识id,
        ...onBudgetQtyFormularRef().getFieldsValue(),
      })
      item.list = array
    }
    item.dynaOptions = item.dynaOptions ? item.dynaOptions : item.productSku?.argMap
    // 处理产品明细
    if (item.packDtlList?.length) {
      item.packDtlList = item.packDtlList.filter(el => el.selectSkuId)
    }
    // 每种类型特殊字段处理
    switch (item.type) {
      case 'ACTIVITY':
        item.activityId = item.activity?.id
        item.activityProductId = item.activityProduct?.id
        item.refItemId = btnInfo?.id // 当前项目id
        delete item.generalId
        break
      case 'UP_DOWN':
        // 升降级 需要传参通项Id
        item.refItemId = btnInfo?.id // 当前项目id
        // item.generalId = currentSearchParams.generalId // 通项id
        break
      case 'SUB':
        item.reduceSourceBudgetDtlId = item.referenceId
        item.refItemId = btnInfo?.id // 当前项目id
        item.generalId = item.generalItemManageId
        break
      case 'ADD':
        item.generalId = item.generalItemManageId
        item.refItemId = btnInfo?.id // 当前项目id
        item.addType = addType
        break
      default:
        break
    }
    return [item]
  }
  const onChangeCalculate = val => {
    if (val) {
      let funcRes: any = ''
      try {
        const func = new Function(`return ${val}`)
        funcRes = func()
      } catch (err) {
        funcRes = false
      }
      funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
      onBudgetQtyFormularRef().setFieldsValue({
        budgetQtyValue: funcRes === false ? '计算式错误' : funcRes,
      })
    }
  }
  const onProductSourceTypeBusChange = e => {
    setProductSourceTypeBus(e)
  }
  const treeData = useMemo(() => {
    const loop = (data: any[]): any[] =>
      data
        .map(item => {
          const strTitle = item.label as string
          const index = strTitle.indexOf(searchValue)
          const beforeStr = strTitle.substring(0, index)
          const afterStr = strTitle.slice(index + searchValue.length)
          const title = strTitle
          if (item.children) {
            return { label: title, title: title, id: item.id, children: loop(item.children) }
          }

          return index > -1
            ? {
                ...item,
                label: title,
                title: title,
              }
            : {
                ...item,
                label: null,
                title: null,
              }
        })
        .filter(item => !!item.title)
    console.log(loop(categoryList), '333333333')

    return loop(categoryList).filter((el: any) => {
      if (!el?.children?.length) {
        return el?.title.indexOf(searchValue) > -1
      } else {
        return el
      }
    })
  }, [searchValue, categoryList])
  const onExpand = (newExpandedKeys: React.Key[]) => {
    setExpandedKeys(newExpandedKeys)
    setAutoExpandParent(false)
  }
  const getParentKey = (id: React.Key, tree: any[]): React.Key => {
    let parentKey: React.Key
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some(item => item.id === id)) {
          parentKey = node.id
        } else if (getParentKey(id, node.children)) {
          parentKey = getParentKey(id, node.children)
        }
      }
    }
    return parentKey!
  }
  const onTreeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    console.log(value, 'value')
    let oneArray = treeToOneArr(categoryList)
    const newExpandedKeys = oneArray
      .map(item => {
        if (item.label.indexOf(value) > -1) {
          return getParentKey(item.id, categoryList)
        }
        return null
      })
      .filter((item, i, self): item is React.Key => !!(item && self.indexOf(item) === i))
    console.log(newExpandedKeys, 'newExpandedKeys包含的项')

    setExpandedKeys(value ? newExpandedKeys : [])
    setSearchValue(value)
    value && setAutoExpandParent(true)
  }
  const treeTitleRender = (nodeData: any) => {
    const { title } = nodeData
    return (
      <div className={styles.treeTitle} title="">
        <Tooltip title={title} placement="topLeft" arrow={false}>
          <span
            className={`${styles.text}  ${searchValue && title?.indexOf(searchValue) > -1 ? styles.highLight_class : ''}`}
          >
            {title}
          </span>
        </Tooltip>
      </div>
    )
  }
  return (
    <SDrawerOrModal
      mode="drawer"
      open={open}
      onCancel={() => {
        onClose(multipleOpen, carData)
      }}
      width={1200}
      title={titleRender()}
      antdProps={{
        footer: null,
        zIndex: 998,
        classNames: {
          body: styles.SelectDrawerBody,
        },
      }}
    >
      <div className={styles.contentBox}>
        <Spin spinning={loading}>
          {selectType === 'ADD' && (
            <div className={styles.tabBar_box}>
              <Tabs items={items} onChange={onAddTypeChange} />
            </div>
          )}
          {(addType === 'PRODUCT' || selectType !== 'ADD') && selectType !== 'SUB' && (
            <div className={styles.left_right_baseBox}>
              <div className={styles.contentBox_left}>
                {(selectType === 'GENERAL' || selectType === 'UP_DOWN') && (
                  <GeneralList
                    data={generalList}
                    generalId={generalId}
                    setGeneralId={setGeneralId}
                  ></GeneralList>
                )}
                {selectType === 'ACTIVITY' && (
                  <GeneralList
                    data={[{ name: '全部', id: 'all' }, ...activityList]}
                    generalId={activityId}
                    setGeneralId={setActivityId}
                    type="ACTIVITY"
                  ></GeneralList>
                )}
                {((addType === 'PRODUCT' && selectType === 'ADD') || selectType === 'PROJECT') && (
                  <div className={styles.contentBox_cateTree_box}>
                    <Search
                      style={{ margin: '12px 8px', width: 144 }}
                      placeholder="搜索空间"
                      onChange={onTreeChange}
                    />
                    <Tree
                      className="draggable-tree"
                      blockNode
                      // onDragEnter={onDragEnter}
                      treeData={treeData}
                      selectedKeys={productCategoryIds}
                      onExpand={onExpand}
                      expandedKeys={expandedKeys}
                      autoExpandParent={autoExpandParent}
                      onSelect={onSelect}
                      fieldNames={{
                        title: 'label',
                        key: 'id',
                        children: 'children',
                      }}
                      titleRender={treeTitleRender}
                      // switcherIcon={switcherIconRender}
                      // showIcon={false}
                    />
                  </div>
                )}
              </div>
              <div className={styles.contentBox_right}>
                <div
                  className={styles.contentBox_right_content}
                  style={{ width: multipleOpen ? '50%' : '100%' }}
                >
                  <div className={styles.contentBox_right_header}>
                    <Search
                      style={{ width: '30%', maxWidth: 200, marginRight: 12 }}
                      placeholder="搜索商品名称/SPU/SKU"
                      onSearch={onSearch}
                      allowClear
                    />
                    {/* <Popover content={content} trigger="hover" placement="bottomLeft" arrow={false}>
                      <div className={styles.headerFilter}>
                        筛选 <FilterOutlined className={styles.icon} />
                      </div>
                    </Popover> */}
                    <div style={{ display: 'flex', gap: '0 12px', flex: 1 }}>
                      {typeSearchFlag[selectType]?.prodType && (
                        <Select
                          // disabled={tableLoading}
                          style={{ width: '35%', maxWidth: 120 }}
                          showSearch
                          value={prodType}
                          onChange={onProductTypeChange}
                          // className={style.categorySelect}
                          placeholder=""
                          options={[
                            { label: '单品+组合', value: 'all' },
                            ...productTypeList?.filter((item: any) =>
                              ['PRODUCT_SINGLE', 'PRODUCT_GROUP'].includes(item.value)
                            ),
                          ]}
                          optionFilterProp="label"
                        />
                      )}
                      {typeSearchFlag[selectType]?.mainMaterial && (
                        <Select
                          // disabled={tableLoading}
                          style={{ width: '30%', maxWidth: 120 }}
                          showSearch
                          value={productSourceTypeBus}
                          onChange={onProductSourceTypeBusChange}
                          // className={style.categorySelect}
                          options={[
                            { label: '主材+施工', value: 'all' },
                            ...productSourceTypeBusList,
                          ]}
                          optionFilterProp="label"
                        />
                      )}
                      {typeSearchFlag[selectType]?.brand && (
                        <Select
                          // disabled={tableLoading}
                          style={{ width: '30%', maxWidth: 200 }}
                          showSearch
                          value={brandId}
                          onChange={onBrandChange}
                          placeholder="全部品牌"
                          // className={style.categorySelect}
                          // onSearch={onSearch}
                          options={[{ label: '全部品牌', value: 'all' }, ...brandList]}
                          optionFilterProp="label"
                        />
                      )}
                    </div>
                  </div>
                  <div className={styles.right_listBox}>
                    {data?.length ? (
                      <ProductList
                        data={data}
                        type={selectType}
                        generalId={generalId}
                        spaceId={spaceId}
                        budgetId={budgetId}
                        multipleOpen={multipleOpen}
                        setSelectMaterialObj={data => {
                          setSelectMaterialObj({ ...data })
                        }}
                        addType={addType}
                        btnInfo={btnInfo}
                        getGeneralList={getGeneralList}
                        reload={clickToSearch}
                      ></ProductList>
                    ) : (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        style={{
                          height: '100%',
                          margin: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                        }}
                      />
                    )}
                  </div>
                  <div className={styles.right_pageBox}>
                    {selectType !== 'SUB' && selectType !== 'ACTIVITY' ? (
                      // &&
                      // !(
                      //   selectType === 'ADD' &&
                      //   ['GENERAL', 'REDUCED_STANDARD'].includes(queryRef?.current?.addType)
                      // )
                      <Pagination
                        total={pagination.total}
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        showSizeChanger
                        pageSizeOptions={['10', '30', '50', '100']}
                        // showQuickJumper
                        showTotal={total => `共 ${total} 条`}
                        onChange={onChangePage}
                        size="small"
                        showLessItems
                      />
                    ) : (
                      <div>当前加载条数：{data.length}</div>
                    )}
                  </div>
                </div>
                <div
                  className={styles.rightBox}
                  style={{ display: multipleOpen ? 'block' : 'none' }}
                >
                  <RightConfigArea
                    selectMaterialObj={selectMaterialObj}
                    currentSearchParams={currentSearchParams}
                    setFullLoading={v => {
                      // setFullLoading(v)
                    }}
                    budgetId={budgetId}
                    type={selectType}
                    setDeleteMaterialObj={data => {
                      // setDeleteMaterialObj({ ...data })
                    }}
                    spaceId={spaceId}
                    data={carData}
                    setData={setCarData}
                    btnInfo={btnInfo}
                    getGeneralList={getGeneralList}
                  />
                </div>
                )
              </div>
            </div>
          )}
          {((selectType === 'ADD' && (addType === 'GENERAL' || addType === 'REDUCED_STANDARD')) ||
            selectType === 'SUB') && (
            <div className={styles.table_choose_box}>
              <div style={{ margin: '12px 0 12px 20px' }}>
                <Search
                  style={{ width: 240 }}
                  placeholder={
                    selectType === 'SUB'
                      ? '搜索商品名称/SKU'
                      : addType === 'GENERAL'
                        ? '搜索通项名称'
                        : '搜索商品名称/SKU'
                  }
                  allowClear
                  onSearch={onSearch}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'column',
                  overflow: 'auto',
                  margin: '0 20px',
                }}
              >
                <Table style={{ width: '100%' }} columns={chooseTableColumn} dataSource={data} />
              </div>
            </div>
          )}
          <SDrawerOrModal
            mode="modal"
            open={budgetQtyFormularOpen}
            loading={qtyFormularLoading}
            onCancel={() => {
              setBudgetQtyFormularOpen(false)
              onBudgetQtyFormularRef().resetFields()
            }}
            styles={{ body: { padding: '0 15px' }, height: 600 }}
            onOk={onBudgetQtyFormularSubmit}
            width={400}
            zIndex={999}
            title="预算量"
            antdProps={{
              ...{
                ...(qtyFormularReadOnly ? { footer: null } : {}),
              },
            }}
          >
            <SGeneralForms
              ref={budgetQtyFormularRef}
              layout={'vertical'}
              configs={[
                {
                  formItem: [
                    {
                      label: '预算量计算式',
                      name: 'budgetQtyFormular',
                      spanCol: 24,
                      comConfig: {
                        onChange: e => onChangeCalculate(e?.target?.value),
                        // disabled: !recordItem?.updateFormularFlag,
                      },
                    },
                    {
                      label: '预算量',
                      name: 'budgetQtyValue',
                      spanCol: 24,

                      comConfig: {
                        disabled: true,
                      },
                    },
                    {
                      label: '备注',
                      name: 'remark',
                      spanCol: 24,
                      type: 'textarea',
                      comConfig: {
                        autoSize: true,
                        maxLength: 255,
                        showCount: true,
                      },
                    },
                  ],
                },
              ]}
            />
          </SDrawerOrModal>

          {confirmOpen && (
            <SubComfirmModal
              open={confirmOpen}
              setOpen={setConfirmOpen}
              record={record}
              type={selectType}
              budgetId={budgetId}
              spaceId={spaceId}
              generalId={generalId}
              btnInfo={btnInfo}
              reload={clickToSearch}
            ></SubComfirmModal>
          )}
        </Spin>
      </div>
    </SDrawerOrModal>
  )
}
